import type { UniDriver } from '@wix/unidriver-core';
import {
  baseUniDriverFactory,
  getDataAttributeValue,
} from '../utils/test-utils/unidriver';

export const sidebarDividerNextDriverFactory = (
  base: UniDriver,
  _body: UniDriver,
) => {
  return {
    ...baseUniDriverFactory(base),

    /**
     * Checks whether SidebarDivider is displayed in full width
     * @returns {Promise<boolean>}
     */
    isFullWidth: async (): Promise<boolean> =>
      (await getDataAttributeValue(base, 'data-full-width')) === 'true',

    /**
     * Returns the divider skin
     * @returns {Promise<string>}
     */
    getSkin: async (): Promise<string | null> =>
      await getDataAttributeValue(base, 'data-skin'),
  };
};

export type SidebarDividerNextUniDriver = ReturnType<
  typeof sidebarDividerNextDriverFactory
>;
